import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function Header({data}) {
    return (
        <div key={data.documentId} className="header">
            <div className="header navbar-div">
                <div className="navbar navbar-static-top">
                    <div className="container-fluid no-padding max-width">

                        <div className="col-md-2 center no-padding" style={{zIndex: 99999}}>
                            <a className="logo navbar-btn navbar-logo" href="/"
                               title="Home">
                                <img className="navbar-logo"
                                     src={data['logo']['url']}
                                     alt="Home"/>
                            </a>
                        </div>

                        <div className="col-sm-10">
                            <div className="container-fluid max-width">
                                <div className="no-mobile-display" style={{margin: -15, marginLeft: -15}}>
                                    <div className="pull-right">
                                        <div className="green-background" style={{}}>
                                            <a className="white-text sponsors-button"
                                               href={data['callToActionLink'].url}>{data['callToActionLink'].label}</a>
                                        </div>
                                    </div>

                                    {/*FIXME: need this to come through the way callToActionLink does and then we can pull it dynamically*/}
                                    <div className="pull-right" style={{padding: 15}}>
                                        <div className="" style={{}}>
                                            <a className="today-air-quality-text pull-right"
                                               href="/current-and-forecasted-air-quality">TODAY'S AIR QUALITY</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="container-fluid max-width nav-menu-parent-div">
                                <div className="">
                                    <div className="region region-navigation">
                                        <nav className="navbar navbar-expand-lg bg-body-tertiary">
                                            <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#navbarSupportedContent"
                                                    aria-controls="navbarSupportedContent" aria-expanded="false"
                                                    aria-label="Toggle navigation">
                                                <span className="navbar-toggler-icon"></span>
                                            </button>
                                            <div className="container-fluid">
                                                {data.linkLists.map((item, itemIdx) => (
                                                    <div key={ itemIdx } className="collapse navbar-collapse"
                                                         id="navbarSupportedContent">
                                                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                            <li className="nav-item dropdown">
                                                                <a className="nav-link dropdown-toggle" href="#"
                                                                   role="button" data-bs-toggle="dropdown"
                                                                   aria-expanded="false">
                                                                    {item['titleLink'].label}
                                                                </a>
                                                                <ul className="dropdown-menu">
                                                                    <li>
                                                                        <a className="dropdown-item"
                                                                           href={item['titleLink'].url}>
                                                                            {item['titleLink'].label}
                                                                        </a>
                                                                    </li>
                                                                    {item['links'].length > 0 ? <li>
                                                                        <hr className="dropdown-divider" style={{borderTop: "2px solid #333", opacity: '0.25'}}/>
                                                                    </li> : null}
                                                                    {item['links'].map((linkItem, linkItemIdx) => (
                                                                        <li key={ linkItemIdx }>
                                                                            <a className="dropdown-item"
                                                                               href={linkItem['url']}>
                                                                                {linkItem['label']}
                                                                            </a>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                ))}
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
);}

export default Header;